import axios from 'axios';
import { toast } from 'react-toastify';
import {
  DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_BEGIN,
  DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_SUCCESS,
  DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_FAILURE,
  DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';

export function deleteDeploymentSetting(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_BEGIN,
    });
    const { projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/deployment/setting/${args.uuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_SUCCESS,
              data: res,
            });
            Mixpanel.track('Deleted Deployment Setting', { uuid: args.uuid });
            toast.success('Deleted Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_FAILURE,
              data: { error: err },
            });
            Mixpanel.track('Failed to delete deployment setting');
            const errMsg = getErrorMessageFromResponse(res);
            toast.success(`Deletion failed: ${errMsg}`);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteDeploymentSettingError() {
  return {
    type: DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_BEGIN:
      return {
        ...state,
        deleteDeploymentSettingPending: true,
        deleteDeploymentSettingError: null,
      };

    case DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_SUCCESS:
      return {
        ...state,
        deleteDeploymentSettingPending: false,
        deleteDeploymentSettingError: null,
      };

    case DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_FAILURE:
      return {
        ...state,
        deleteDeploymentSettingPending: false,
        deleteDeploymentSettingError: action.data.error,
      };

    case DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_DISMISS_ERROR:
      return {
        ...state,
        deleteDeploymentSettingError: null,
      };

    default:
      return state;
  }
}
